module.exports = __webpack_public_path__ + "static/media/bone.4797d75f.png";